import { useWSModal, WSMenuItem } from "@wingspanhq/fe-component-library";
import {
  RecurringDocumentStatus,
  RecurringInvoice
} from "@wingspanhq/wingspan-api-sdk";
import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { selectorIsRecurringInvoiceMutable } from "../../../../shared/selectors/selectorIsRecurringInvoiceMutable";
import { selectorRecurringInvoiceActionLabels } from "../../../../shared/selectors/selectorRecurringInvoiceActionLabels";
import { useSetWSStore } from "../../../../store";
import { ModalDelete } from "./ModalDelete";

export const useGetActions = () => {
  const history = useHistory();
  const location = useLocation();
  const setStore = useSetWSStore();
  const modalDelete = useWSModal(ModalDelete, { size: "S" });

  return useCallback(
    (recurringInvoice: RecurringInvoice) => {
      const menuItems: WSMenuItem[] = [];
      const labels = selectorRecurringInvoiceActionLabels(recurringInvoice);

      if (selectorIsRecurringInvoiceMutable(recurringInvoice)) {
        menuItems.push({
          icon: "edit",
          label: labels.edit,
          onClick: () => {
            setStore({ invoiceFormBackPath: location.pathname });
            history.push(
              `/member/invoices/template/${recurringInvoice.id}/edit`
            );
          }
        });

        menuItems.push({
          icon: "plus-circle",
          label: "Duplicate",
          onClick: () => {
            history.push(
              `/member/invoices/template/${recurringInvoice.id}/duplicate`
            );
          }
        });
      }

      if (recurringInvoice.status === RecurringDocumentStatus.DRAFT) {
        menuItems.push({
          icon: "exit",
          label: "Remove",
          onClick: () => {
            modalDelete.open({ recurringInvoice });
          }
        });
      }

      if (recurringInvoice.status === RecurringDocumentStatus.ACTIVE) {
        menuItems.push({
          icon: "exit",
          label: labels.cancel,
          onClick: () => {
            modalDelete.open({ recurringInvoice });
          }
        });
      }

      return menuItems;
    },
    [history, location.pathname, modalDelete, setStore]
  );
};
